/* PavCon, LLC Proprietary.All rights reserved 2022 */
const INITIAL_STATE: AppParamsState = {
  id: null,
  criteria: null,
};

export const NAMESPACE = 'PARAMS';

export const AppParamsActions = {
  INIT: `${NAMESPACE}.INIT`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  UPDATE_STATE_AND_LS: `${NAMESPACE}.UPDATE_STATE_AND_LS`,
  UPDATE_STATE_AND_REMOVE_LS: `${NAMESPACE}.UPDATE_STATE_AND_REMOVE_LS`,
  SET_ID: `${NAMESPACE}.SET_ID`,
  SET_FILTERS: `${NAMESPACE}.SET_FILTERS`,
};

export const AppParamsReducer = (state: AppParamsState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case AppParamsActions.INIT:
      return { ...INITIAL_STATE };
    case AppParamsActions.KEEP_CURRENT_STATE:
      return state;
    case AppParamsActions.UPDATE_STATE_AND_LS:
      return {
        ...state,
        ...action.payload
      };
    case AppParamsActions.UPDATE_STATE_AND_REMOVE_LS:
      return { ...INITIAL_STATE };
    case AppParamsActions.SET_ID:
      return {
        ...state,
        id: action.payload
      };
    case AppParamsActions.SET_FILTERS:
      return {
        ...state,
        criteria: action.payload?.criteria || action.payload,
        id: action.payload?.id || state.id
      };
    default:
      return state;
  }
};

export interface AppParamsState {
  id: any;
  criteria: string;
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
  2020 WARNING: this file may contain export controlled information.*/
